export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=sa.sahabalalam.app'
export const APP_STORE_URL = 'https://apps.apple.com/app/id6794865950'

export const getDeviceType = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera || ''
    const platform = navigator.platform || ''
    const maxTouchPoints = navigator.maxTouchPoints || 0

    // iPadOS 13+ can report as Mac — treat touch Mac as iOS
    const isIos =
        /iPad|iPhone|iPod/.test(ua) ||
        (platform === 'MacIntel' && maxTouchPoints > 1)

    if (isIos && !window.MSStream) return 'ios'
    if (/android/i.test(ua)) return 'android'
    return 'desktop'
}

/** Redirect phones to the correct store. Returns true if a redirect was started. */
export const redirectToAppStore = () => {
    const device = getDeviceType()
    if (device === 'ios') {
        window.location.replace(APP_STORE_URL)
        return true
    }
    if (device === 'android') {
        window.location.replace(PLAY_STORE_URL)
        return true
    }
    return false
}
